import { MuiIcon } from "@/app/components/studio/MuiIcon";

interface RatingProps {
	rating: number;
	color?: string;
}

const Rating = ({ rating, color = "#FFD600" }: RatingProps) => {
	const fullStars = Math.floor(rating);
	const hasHalf = rating - fullStars >= 0.5;
	const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

	return (
		<>
			{[...Array(fullStars)].map((_, i) => (
				<MuiIcon
					key={`star-full-${i}`}
					iconName="star"
					iconColor={color}
					style={{ fontSize: 18 }}
				/>
			))}
			{hasHalf && (
				<MuiIcon
					iconName="star_half"
					iconColor={color}
					style={{ fontSize: 18 }}
				/>
			)}
			{[...Array(emptyStars)].map((_, i) => (
				<MuiIcon
					key={`star-empty-${i}`}
					iconName="star_border"
					iconColor={color}
					style={{ fontSize: 18 }}
				/>
			))}
		</>
	);
};

export default Rating;
